import { ErrorHandler, Injector, Injectable } from "@angular/core";
import { ApplicationInsightsService } from "./appinsights.service";

@Injectable()
export class ApplicationInsightsErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    this.injector
      .get<ApplicationInsightsService>(ApplicationInsightsService)
      .logException(error);
    console.error(error);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/logger/errorhandler.service.ts